/* eslint-disable import/no-extraneous-dependencies */

import Admin from 'hive-admin';

import getFilterWithCol from '../../../helpers/getFilterWithCol';
// import { sizeChoices } from '../helpers';

import Types from '../../../modules/types';

const {
  CONTENT_BUILDER_EFFECT: { TYPE_MAP: CBEF_MAP },
} = Types;

const isNotTransitionFrame = Admin.compileFromLibrary([
  'condition.testFieldValue',
  'type',
  '!==',
  'TRANSITION_FRAME',
]);

const isNotTransitionText = Admin.compileFromLibrary([
  'condition.testFieldValue',
  'type',
  '!==',
  'TRANSITION_TEXT',
]);

const isTransitionEaseTypeLinear = Admin.compileFromLibrary([
  'condition.testFieldValue',
  'easeType',
  (value) => ['AUTO', 'LINEAR'].includes(value),
]);

const ITEM_FIELDS = Admin.compileFromLibrary([
  getFilterWithCol(['FieldText', {
    label: null,
    prefix: 'Duration:',
    name: 'duration',
  }], 12),
  getFilterWithCol(['FieldText', {
    label: null,
    prefix: 'Delay:',
    name: 'delay',
  }], 12),
  getFilterWithCol(['FieldRadio', {
    label: null,
    name: 'easeType',
    initialValue: 'AUTO',
    choices: [{
      label: 'Auto',
      value: 'AUTO',
    }, {
      label: 'Linear',
      value: 'LINEAR',
    }, {
      label: 'Ease In',
      value: 'EASE_IN',
    }, {
      label: 'Ease Out',
      value: 'EASE_OUT',
    }, {
      label: 'Ease',
      value: 'EASE_IN_OUT',
    }],
    block: true,
  }], 24),
  getFilterWithCol(['FieldSelect', {
    label: null,
    prefix: 'Easing:',
    name: 'easeFunction',
    initialValue: 'QUINT',
    choices: [
      'SINE',
      'QUAD',
      'CUBIC',
      'QUART',
      'QUINT',
      'EXPO',
      'CIRC',
      'BACK',
    ].map(value => ({
      value,
      label: `${value[0]}${value.slice(1).toLowerCase()}`,
    })),
    skip: [isTransitionEaseTypeLinear],
  }], 24),
], true);

export default [
  ...[
    [
      CBEF_MAP.TRANSITION_FRAME,
      isNotTransitionFrame,
    ],
    [
      CBEF_MAP.TRANSITION_TEXT,
      isNotTransitionText,
    ],
  ].reduce(
    (agr, [{ id, children, propertyChoices }, isNotTypeTest]) => {
      const inputName = `${id.toLowerCase()}_items`;
      const fieldName = `FieldContentBuilder:EFFECT:${id}`;
      const FIELDS = Admin.compileFromLibrary([
        ['FieldSelect', {
          label: null,
          prefix: 'Property:',
          name: 'property',
          initialValue: propertyChoices[0].value,
          choices: propertyChoices,
        }],
        ...ITEM_FIELDS,
      ], true);
      Admin.addToLibrary(
        fieldName,
        (config = {}) => Admin.compileFromLibrary(['FieldContentBuilderNodes', {
          name: inputName,
          preSkip: [isNotTypeTest],
          addButtonLabel: 'Add Transition',
          pasteButtonLabel: 'Paste Transition',
          toolbarProps: {
            itemsLabelsMap: { '*': 'Property Transition' },
          },
          copyRealm: `ContentBuilder:Effect:${id}:transition_items`,
          pasteRealm: `ContentBuilder:Effect:${id}:transition_items:*`,
          targetable: false,
          nodeType: children[inputName].node,
          ...config,
          fields: FIELDS,
        }]),
      );
      agr.push([fieldName, {
        name: inputName,
      }]);
      return agr;
    },
    [],
  ),

  // ...[

  // ].map(([fieldType, fieldConfig]) => Admin.compileFromLibrary([
  //   fieldType,
  //   {
  //     ...fieldConfig,
  //     preSkip: [isNotShadow, ...(fieldConfig.preSkip || [])],
  //   },
  // ])),

];
